// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import IconShipping from 'components/atoms/icons/IconShipping';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCollectedTotalWeight } from 'redux/slices/collectingRoute';
import { useEffect } from 'react';
import { getRoutesCollectedTotalWeight } from 'apis/collect_route';
import { normalizeNumber } from 'util/commons';

type Props = {
  handleOnClick?: () => void;
};

const ButtonLoadingVolume = ({ handleOnClick }: Props) => {
  const { t } = useTranslation();
  const totalCollectedWeight = useSelector(selectCollectedTotalWeight);

  useEffect(() => {
    if (totalCollectedWeight != null) {
      return;
    }

    getRoutesCollectedTotalWeight();
  }, []);

  return (
    <button
      className={styles.loadingVolumeButton}
      type="button"
      onClick={handleOnClick}
    >
      <div className={styles.iconShipping}>
        <IconShipping size={28} />
      </div>

      <div className={styles.loadingVolume}>
        <div className={styles.loadingVolumeTitle}>
          {t('route_list.loading_volume')}
        </div>
        <div className={styles.loadingVolumeNumber}>
          {normalizeNumber({
            value: totalCollectedWeight || '0',
          })}{' '}
          kg
        </div>
      </div>
    </button>
  );
};

export default ButtonLoadingVolume;
